import { Container, Stack } from "@fideus-ui/core";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";
import { useIsFeatureEnabled } from "../../../_app/featureFlags";
import { AnnualStatementCommentsSection } from "../../../companies/comments/AnnualStatementCommentsSection";
import { AnnualStatementNoteSection } from "../../../companies/notes/AnnualStatementNoteSection";
import { DisclosureReviewTab } from "../../../companies/offenlegung/DisclosureReviewTab";
import { ReviewTab } from "../../../companies/review/ReviewTab";
import { ServiceTasksTab } from "../../../companies/serviceTasks/ServiceTasksTab";

const companyRoute = getRouteApi("/firmen/$companyId");

export const Route = createFileRoute("/firmen/$companyId/vorgaenge")({
  loader: async ({ context: { queryClient, trpc }, params: { companyId } }) => {
    void queryClient.ensureQueryData(
      trpc.serviceTasks.listServiceTasksByCompanyId.queryOptions({ companyId })
    );
    void queryClient.ensureQueryData(
      trpc.taxAdvisorReviews.listTaxAdvisorReviews.queryOptions({ companyId })
    );
    void queryClient.ensureQueryData(
      trpc.disclosureReviews.listDisclosureReviews.queryOptions({ companyId })
    );
    void queryClient.ensureQueryData(
      trpc.annualStatements.listAnnualStatementsByCompanyId.queryOptions({
        companyId,
      })
    );
  },
  component: VorgaengeRoute,
});

function VorgaengeRoute() {
  const { companyId } = Route.useParams();
  const { jahr } = companyRoute.useSearch();
  const isDisclosureReviewEnabled = useIsFeatureEnabled(
    "disclosureReviewInServicePortal"
  );
  return (
    <Container>
      <Stack spacing={3}>
        <ServiceTasksTab companyId={companyId} year={jahr} />
        <AnnualStatementNoteSection
          companyId={companyId}
          selectedYear={jahr ?? null}
        />
        <ReviewTab companyId={companyId} selectedYear={jahr ?? null} />
        {isDisclosureReviewEnabled && (
          <DisclosureReviewTab
            companyId={companyId}
            selectedYear={jahr ?? null}
          />
        )}
        <AnnualStatementCommentsSection
          companyId={companyId}
          selectedYear={jahr ?? null}
        />
      </Stack>
    </Container>
  );
}
